import type { GlyphName } from "@/lib/glyphs";

export interface Destination {
  to: string;
  label: string;
  glyph: GlyphName;
  /** Also current on these path prefixes, for screens that live under this one. */
  also?: string[];
  needs?: boolean;
}

export const MAIN_NAV: Destination[] = [
  { to: "/", label: "Home", glyph: "home" },
  { to: "/needs-you", label: "Needs you", glyph: "person", needs: true, also: ["/m"] },
  { to: "/cases", label: "Cases", glyph: "cases", also: ["/war-rooms"] },
  { to: "/flows", label: "Flows", glyph: "flows", also: ["/autonomy", "/templates"] },
  { to: "/crew", label: "Crew", glyph: "people", also: ["/agents"] },
  { to: "/guardian", label: "Guardian", glyph: "shield" },
  { to: "/outcomes", label: "Outcomes", glyph: "bars" },
  { to: "/ask", label: "Ask", glyph: "chat" },
  { to: "/knowledge", label: "Knowledge", glyph: "book" },
  { to: "/estate", label: "Estate", glyph: "servers" },
  { to: "/connections", label: "Connections", glyph: "plug" },
];

export const BOTTOM_NAV: Destination[] = [
  { to: "/settings", label: "Settings", glyph: "gear" },
  { to: "/help", label: "Help", glyph: "help" },
];

/** On a phone the rail becomes four tabs along the bottom, then More for everything else. */
export const PHONE_TABS: Destination[] = MAIN_NAV.filter((d) =>
  ["/", "/needs-you", "/cases", "/flows"].includes(d.to),
);

/** Every other destination, in the order the rail shows them, for the phone's More sheet. */
export const MORE_NAV: Destination[] = [...MAIN_NAV, ...BOTTOM_NAV].filter(
  (d) => !PHONE_TABS.includes(d),
);

export function isCurrent(item: Destination, pathname: string): boolean {
  if (item.to === "/") return pathname === "/";
  return [item.to, ...(item.also ?? [])].some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
